import {invalid} from "./common";
const _ = require("lodash");

export function get(o, key){
  //忽略key大小写来获取值
  let value = o[key];
  if (!invalid(value)) return value;
  key = key.toLowerCase();
  for (let e in o) {
    if (e.toLowerCase() === key) {
      return o[e];
    }
  }
}

//忽略大小写的set
export function set(o, key,value){
  deleteValue(o,key);
  o[key]=value;
}

//忽略大小写的delete
export function deleteValue(o, key){
  let lowerKey = key.toLowerCase();
  for (let e in o) {
    if (e.toLowerCase() === lowerKey) {
      delete o[e];
      return;
    }
  }
}

export function deleteValues(o, keys){
  keys.forEach((key)=>{
    deleteValue(o,key);
  });
}

function tryJSON(obj) { //如果value能转换成json对象，那么转换并返回，否则返回原值
  if(_.isObject(obj)){
    _.forOwn(obj, (value, key)=> {
      obj[key]=tryJSON(value);
    });
    return obj;
  }
  
  if(_.isArray(obj)){
    for(let i=0;i<obj.length;i++){
      obj[i]=tryJSON(obj[i]);
    }
    return obj;
  }

  return tryJSONValue(obj);
}


function tryJSONValue(value) { //如果value能转换成json对象，那么转换并返回，否则返回原值
  if (typeof value === 'string') {
    try {
      let obj = JSON.parse(value);
      if (_.isObject(obj)) return obj;
    } catch (e) {
      
    }
  }
  return value;
}

export const JSON = {
  try:tryJSON,
  parse:window.JSON.parse,
  stringify:window.JSON.stringify
}

